import { get, put } from 'common/api';

export const getMe = () => get('/v5/users/me');
export const updateMe = payload => put('/v5/users/me', payload);
export const getMeAccounts = payload => get('/v5/users/me/accounts', payload);
